import React, { useEffect, useRef } from 'react';

const AnimatedBackground = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let animId;
    let w, h;

    const resize = () => {
      w = canvas.width = window.innerWidth;
      h = canvas.height = window.innerHeight;
    };
    resize();
    window.addEventListener('resize', resize);

    // Particles
    const particles = Array.from({ length: 60 }, () => ({
      x: Math.random() * window.innerWidth,
      y: Math.random() * window.innerHeight,
      r: Math.random() * 2 + 0.5,
      vx: (Math.random() - 0.5) * 0.3,
      vy: (Math.random() - 0.5) * 0.3,
      color: [
        'rgba(46, 90, 255,',
        'rgba(138, 43, 226,',
        'rgba(255, 59, 154,',
      ][Math.floor(Math.random() * 3)],
      alpha: Math.random() * 0.6 + 0.2,
    }));

    // Orbiting circles
    const orbs = [
      { cx: 0.15, cy: 0.25, r: 120, speed: 0.0003, color: 'rgba(46, 90, 255, 0.06)', phase: 0 },
      { cx: 0.85, cy: 0.2, r: 160, speed: 0.0002, color: 'rgba(138, 43, 226, 0.05)', phase: 1 },
      { cx: 0.7, cy: 0.75, r: 140, speed: 0.00025, color: 'rgba(255, 59, 154, 0.05)', phase: 2 },
    ];

    let t = 0;

    const draw = () => {
      ctx.clearRect(0, 0, w, h);
      t += 1;

      // Draw orbit rings
      orbs.forEach(orb => {
        const cx = orb.cx * w + Math.sin(t * orb.speed + orb.phase) * 40;
        const cy = orb.cy * h + Math.cos(t * orb.speed + orb.phase) * 20;

        ctx.beginPath();
        ctx.arc(cx, cy, orb.r, 0, Math.PI * 2);
        ctx.strokeStyle = orb.color.replace('0.0', '0.15');
        ctx.lineWidth = 1;
        ctx.stroke();

        // Inner glow
        const grad = ctx.createRadialGradient(cx, cy, orb.r * 0.5, cx, cy, orb.r);
        grad.addColorStop(0, orb.color + '0.15)');
        grad.addColorStop(1, orb.color + '0)');
        ctx.beginPath();
        ctx.arc(cx, cy, orb.r, 0, Math.PI * 2);
        ctx.fillStyle = grad;
        ctx.fill();
      });

      // Connect nearby particles
      particles.forEach((p, i) => {
        particles.slice(i + 1).forEach(q => {
          const dx = p.x - q.x, dy = p.y - q.y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < 120) {
            ctx.beginPath();
            ctx.moveTo(p.x, p.y);
            ctx.lineTo(q.x, q.y);
            ctx.strokeStyle = `rgba(46,90,255,${0.08 * (1 - dist / 120)})`;
            ctx.lineWidth = 0.5;
            ctx.stroke();
          }
        });
      });

      // Draw & move particles
      particles.forEach(p => {
        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = p.color + p.alpha + ')';
        ctx.fill();
        p.x += p.vx;
        p.y += p.vy;
        if (p.x < 0) p.x = w;
        if (p.x > w) p.x = 0;
        if (p.y < 0) p.y = h;
        if (p.y > h) p.y = 0;
      });

      animId = requestAnimationFrame(draw);
    };

    draw();
    return () => {
      cancelAnimationFrame(animId);
      window.removeEventListener('resize', resize);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 0,
      }}
    />
  );
};

export default AnimatedBackground;
